import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'

import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { CreateJobAction } from '../../redux/actions/job'
import * as types from '../../redux/constantes/job'

import { ContainerContent, ContainerTemplate } from '../../components/Containers'
import { MessageBoxAlert, MessageBoxError, MessageBoxSuccess } from '../../components/MessageBox'
import { WrapperButtonsModal } from '../../components/Modal/style'
import { InputText } from '../../components/InputText'
import { ButtonSend } from '../../components/ButtonSend'
import { Header } from '../../components/Header'
import { Title } from '../../components/Title'
import { Wrapper } from '../../components/Wrapper'
import { TextArea } from '../../components/TextArea'
import { InputSalary } from '../../components/InputSalary'
import { Select } from '../../components/Select'
import { arrayArea } from '../../helpers/area'
import { arrayModalidade } from '../../helpers/modalidade'
import { ButtonRedirect } from '../../components/ButtonRedirect'
import { initialStateProps } from '../../redux/reducer/infosPage'

export const TemplateNewJob: React.FC = () => {
  const history = useHistory()

  const [office, setOffice] = useState('')
  const [place, setPlace] = useState('')
  const [area, setArea] = useState<string>()
  const [modality, setModality] = useState<string>()
  const [salary, setSalary] = useState('')
  const [description, setDescription] = useState('')
  const [activities, setActivities] = useState('')
  const [requirements, setRequirements] = useState('')
  const [benefits, setBenefits] = useState('')

  const [question1, setQuestion1] = useState('')
  const [question2, setQuestion2] = useState('')

  const [activeQuestion1, setActiveQuestion1] = useState(false)
  const [activeQuestion2, setActiveQuestion2] = useState(false)
  const [activeQuestionSalary, setActiveQuestionSalary] = useState(false)

  const { loading, success, error } = useSelector((state: RootStateOrAny) => state.createJob)
  const state: initialStateProps = useSelector((state: RootStateOrAny) => state.infoPages)
  const dispatch = useDispatch()

  const onSubmit = () => {
    dispatch(
      CreateJobAction(
        state.key,
        office,
        place,
        area as string,
        modality as string,
        salary,
        description,
        activities,
        requirements,
        benefits,
        question1,
        question2,
        activeQuestionSalary ? 'Qual sua pretensão salarial: ' : ''
      )
    )
  }

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        dispatch({ type: types.CREATE_JOB_RESET })
        history.push('/admin')
      }, 5000)
    }
    if (error) {
      setTimeout(() => {
        dispatch({ type: types.CREATE_JOB_RESET })
      }, 5000)
    }
  }, [success, error])

  return (
    <ContainerTemplate>
      {state.key !== process.env.REACT_APP_KEY && <Header text="Acesso Negado" />}
      {state.key === process.env.REACT_APP_KEY && (
        <>
          <Header text="Gestão de Vagas" />
          <ContainerContent>
            <Title text="Cadastrar Vaga" />
            <Wrapper>
              <InputText
                label="Cargo"
                onChange={e => setOffice(e.target.value)}
                placeholder="exemplo: Analista de Faturamento Hospitalar PL"
                value={office}
                widthDiv="74%"
              />
              <InputText
                label="Local"
                onChange={e => setPlace(e.target.value)}
                placeholder="exemplo: Florianópolis-SC"
                value={place}
                widthDiv="24%"
              />
            </Wrapper>
            <Wrapper>
              <Select
                text="Área"
                array={arrayArea}
                value={area as string}
                handleChange={e => setArea(e.target.value)}
                widthDiv="36%"
                label="Área"
              />
              <Select
                text="Modalidade"
                array={arrayModalidade}
                value={modality as string}
                handleChange={e => setModality(e.target.value)}
                widthDiv="36%"
                label="Modalidade"
              />
              <InputSalary
                label="Salário"
                setSalary={setSalary}
                placeholder="exemplo: R$ 25.000,00"
                salary={salary}
                widthDiv="24%"
              />
            </Wrapper>
            <Wrapper>
              <TextArea
                label="Descrição"
                onChange={e => setDescription(e.target.value)}
                placeholder="Sobre a vaga..."
                value={description}
                widthDiv="48%"
              />
              <TextArea
                label="Atividades"
                onChange={e => setActivities(e.target.value)}
                placeholder="Sobre as atividades..."
                value={activities}
                widthDiv="48%"
              />
            </Wrapper>
            <Wrapper>
              <TextArea
                label="Requisitos"
                onChange={e => setRequirements(e.target.value)}
                placeholder="Sobre os requisitos..."
                value={requirements}
                widthDiv="48%"
              />
              <TextArea
                label="Benefícios"
                onChange={e => setBenefits(e.target.value)}
                placeholder="Sobre os benefícios..."
                value={benefits}
                widthDiv="48%"
              />
            </Wrapper>
            <Wrapper>
              <ButtonSend
                color={!activeQuestion1 ? 'alert' : 'error'}
                nameButton={`${!activeQuestion1 ? 'Ativar' : 'Desativar'} Pergunta 1`}
                widthButton="32%"
                onClick={() => setActiveQuestion1(!activeQuestion1)}
              />
              <ButtonSend
                color={!activeQuestion2 ? 'alert' : 'error'}
                nameButton={`${!activeQuestion2 ? 'Ativar' : 'Desativar'} Pergunta 2`}
                widthButton="32%"
                onClick={() => setActiveQuestion2(!activeQuestion2)}
              />
              <ButtonSend
                color={!activeQuestionSalary ? 'alert' : 'error'}
                nameButton={`${!activeQuestionSalary ? 'Ativar' : 'Desativar'} Pretensão Salarial`}
                widthButton="32%"
                onClick={() => setActiveQuestionSalary(!activeQuestionSalary)}
              />
            </Wrapper>
            {activeQuestion1 && (
              <Wrapper>
                <InputText
                  label="Pergunta 1 (obs¹: Não use ? na pergunta | obs²: Deve ser uma pergunta cuja a resposta seja SIM ou NÃO)"
                  onChange={e => setQuestion1(e.target.value)}
                  placeholder="exemplo: Você tem conhecimento em HTML:"
                  value={question1}
                />
              </Wrapper>
            )}
            {activeQuestion2 && (
              <Wrapper>
                <InputText
                  label="Pergunta 2 (obs¹: Não use ? na pergunta | obs²: Deve ser uma pergunta cuja a resposta seja SIM ou NÃO)"
                  onChange={e => setQuestion2(e.target.value)}
                  placeholder="exemplo: Você tem conhecimento em HTML:"
                  value={question2}
                />
              </Wrapper>
            )}
            <WrapperButtonsModal>
              <ButtonRedirect nameButton="Voltar" link="/admin" />
              <ButtonSend color="success" nameButton="Cadastrar" onClick={onSubmit} />
            </WrapperButtonsModal>

            {loading && <MessageBoxAlert>Aguarde...</MessageBoxAlert>}
            {success && <MessageBoxSuccess>{success}</MessageBoxSuccess>}
            {error && <MessageBoxError>{error}</MessageBoxError>}
          </ContainerContent>
        </>
      )}
    </ContainerTemplate>
  )
}
